import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { LaborService } from '../labor.service';
import { TreeNode, TreeComponent, TreeModel, TREE_ACTIONS, KEYS, IActionMapping, ITreeOptions } from 'angular-tree-component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { DataService } from '../data.service';

@Component({
  selector: 'app-laborsearch',
  templateUrl: './laborsearch.component.html',
  styleUrls: ['./laborsearch.component.css']
})
export class LaborsearchComponent implements OnInit {
  vinNumber = '2HNYD28347H528285';
  prodemandPath = '';
  allDataPath = '';
  selectedParts = [];
  vehicleInfo = {};
  laborName = '';
  partNumber = '';

  constructor(
    private dialogRef: MatDialogRef<LaborsearchComponent>,
    private dataShareService: DataService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.vinNumber = data.currentVinNumber;
    this.prodemandPath = data.prodemandPath;
    this.allDataPath = data.allDataPath;
    this.laborName = data.laborGuide.Title;

    this.dataShareService.shareDataSubject.subscribe(receiveddata => {      
      this.selectedParts = receiveddata;
      this.partNumber = receiveddata.join(',');
    });

    this.dataShareService.vehicleIdSubject.subscribe(vehicleInfo => {
      this.vehicleInfo = vehicleInfo;      
    });
  }

  ngOnInit() {

  }

  loadAppData(appData: any): void {
    this.allDataPath = appData['AllDataPath'];
    this.prodemandPath = appData['ProdemandPath'];
    this.partNumber = appData['PartNumbers'].join(',');
    this.selectedParts = appData['PartNumbers'];
  }

  saveProdemand(prodemandPath: string): void {
    console.log(prodemandPath);
    this.prodemandPath = prodemandPath;
  }

  saveAllData(allDataPath: string): void {
    this.allDataPath = allDataPath;
  }

  save(): void {
    this.dialogRef.close({
      prodemandPath: this.prodemandPath,
      allDataPath: this.allDataPath,
      selectedParts: this.selectedParts,
      vehicleInfo: this.vehicleInfo,
      action: 'save'
    });
  }
}
